import React from 'react';

/**
 * Renders a colored badge showing the payment method with the real brand logo (SVG inline).
 * Used both in the orders list cards and in the order detail card.
 */
export const PaymentMethodBadge = ({ method, size = 'sm' }) => {
  const raw = (method || '').toString().toLowerCase();
  const compact = size === 'sm';
  const cls = `inline-flex items-center gap-1.5 rounded-md font-semibold border ${compact ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs'}`;

  // Detect provider
  const isStripe = raw === 'stripe' || raw.includes('carte') || raw.includes('credit') || raw.includes('crédit') || raw === 'card' || raw === 'link';
  const isPaypal = raw === 'paypal' || raw.includes('paypal');
  const isBank = raw === 'bank_transfer' || raw.includes('virement');
  const isCod = raw === 'cod' || raw === 'cash_on_delivery' || raw.includes('espèce') || raw.includes('livraison');
  const isCheque = raw === 'cheque' || raw.includes('chèque');

  if (isStripe) {
    const isLink = raw === 'link';
    return (
      <span className={`${cls} bg-[#635BFF]/10 text-[#635BFF] border-[#635BFF]/30`} data-testid="pm-badge-stripe">
        <svg viewBox="0 0 60 25" width={compact ? 30 : 38} height={compact ? 13 : 16} aria-hidden="true">
          <path fill="#635BFF" d="M59.64 14.28h-8.06c.19 1.93 1.6 2.55 3.2 2.55 1.64 0 2.96-.37 4.05-.95v3.32a8.33 8.33 0 0 1-4.56 1.1c-4.01 0-6.83-2.5-6.83-7.48 0-4.19 2.39-7.52 6.3-7.52 3.92 0 5.96 3.28 5.96 7.5 0 .4-.04 1.26-.06 1.48zm-5.92-5.62c-1.03 0-2.17.73-2.17 2.58h4.25c0-1.85-1.07-2.58-2.08-2.58zM40.95 20.3c-1.44 0-2.32-.6-2.9-1.04l-.02 4.63-4.12.87V5.57h3.65l.14 1.06c.5-.42 1.62-1.32 3.24-1.32 2.9 0 5.62 2.61 5.62 7.44 0 5.27-2.68 7.55-5.61 7.55zm-.98-11.36c-.94 0-1.55.34-1.99.84v6.02c.41.44 1.02.7 1.98.7 1.55 0 2.6-1.68 2.6-3.78 0-2.05-1.07-3.78-2.6-3.78zm-9.62 3.63l-.4 6.99h-3.98v-6.99h-.02L26 5.57h3.98l.4 6.99h.02L30.4 5.57h3.98l-.4 6.99z"/>
        </svg>
        {isLink ? 'Link' : 'Stripe'}
      </span>
    );
  }
  if (isPaypal) {
    return (
      <span className={`${cls} bg-[#003087]/10 text-[#003087] border-[#003087]/30`} data-testid="pm-badge-paypal">
        <svg viewBox="0 0 24 24" width={compact ? 12 : 14} height={compact ? 12 : 14} aria-hidden="true">
          <path fill="#003087" d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.322 2.564.985 4.567l-.023.15v.998l.633.359a3.796 3.796 0 0 1 1.35 1.055c.622.812.827 1.847.585 3.083-.267 1.472-.723 2.775-1.35 3.865a6.994 6.994 0 0 1-2.14 2.4c-.834.582-1.813 1.02-2.923 1.293-1.075.269-2.303.4-3.647.4h-.863c-.62 0-1.163.443-1.24 1.055v.108l-.79 5.005-.032.155a.34.34 0 0 1-.108.229.323.323 0 0 1-.211.075z"/>
        </svg>
        PayPal
      </span>
    );
  }
  if (isBank) {
    return <span className={`${cls} bg-slate-100 text-slate-700 border-slate-200`} data-testid="pm-badge-bank">🏦 Virement</span>;
  }
  if (isCod) {
    return <span className={`${cls} bg-emerald-50 text-emerald-700 border-emerald-200`} data-testid="pm-badge-cod">💶 Espèces à livraison</span>;
  }
  if (isCheque) {
    return <span className={`${cls} bg-slate-100 text-slate-700 border-slate-200`} data-testid="pm-badge-cheque">📝 Chèque</span>;
  }
  return <span className={`${cls} bg-slate-100 text-slate-600 border-slate-200`} data-testid="pm-badge-other">{method || 'Non précisé'}</span>;
};

export default PaymentMethodBadge;
